import { Box, Tag, TagColor, Text } from '@factorialco/deprecated-design-system'
import { CoffreFortStatusFragment } from 'generated/resources/graphql'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { State } from 'modules/coffrefortnumerique/lib/enums'
import { Stateable } from 'modules/coffrefortnumerique/lib/enums'

interface Props {
  status: CoffreFortStatusFragment
}

export const nextCronCalendar = (): string => {
  const dailyCron = `${moment().format('YYYY-MM-DD')}T09:00:00Z`

  return moment(dailyCron).add(1, 'days').calendar()
}

const syncTextCalendar = (status: CoffreFortStatusFragment): string => {
  const dateStatus = moment(status.stateUpdatedAt)
  const differenceDate = moment().diff(dateStatus, 'days') + 1

  if (status.state === State.Pending) return nextCronCalendar()

  const state_updated_at = moment().set({
    hour: dateStatus.get('hour'),
    minute: dateStatus.get('minute'),
  })

  return state_updated_at.subtract(differenceDate, 'days').calendar()
}

const getState = (state: string): State => {
  switch (state) {
    case State.Failed:
      return State.Failed
    case State.Pending:
      return State.Pending
    default:
      return State.Ready
  }
}

const CoffreFortNumeriqueTag = ({ status }: Props) => {
  let state = getState(status.state)

  if (
    status.stateableType === Stateable.Document &&
    status.state !== (State.Pending || State.Ready)
  )
    state = State.Pending

  const statusToTagColor: Record<State, TagColor> = {
    pending: TagColor.champagne,
    ready: TagColor.viridian,
    failed: TagColor.radical,
  }

  const statusLabel: Record<State, string> = {
    pending: i18n.t('settings.edit_company.coffre_fort_numerique_form.status.pending'),
    ready: i18n.t('settings.edit_company.coffre_fort_numerique_form.status.ready'),
    failed: i18n.t('settings.edit_company.coffre_fort_numerique_form.status.failed'),
  }

  return (
    <Box width="full" flexDirection="row" gap="s16">
      <Tag leftItem="circle" showCircle type={statusToTagColor[state]}>
        {statusLabel[state]}
      </Tag>
      <Text.Normal size="200">{syncTextCalendar(status)}</Text.Normal>
    </Box>
  )
}

export default CoffreFortNumeriqueTag
